Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.validationApiMethodType = "GET";
exports.exampleAPiEndPoint = "EXAMPLE_URL";
exports.exampleAPiMethod = "POST";
exports.exampleApiContentType = "application/json";
exports.textInputPlaceHolder = "Enter Text";
exports.labelTitleText = "cfb2borderreport3";
exports.labelBodyText = "cfb2borderreport3 Body";

exports.btnExampleTitle = "CLICK ME";
exports.stringsListPage_selectAll = "Select All";
exports.stringsListPage_select_store = "Select Store";
exports.stringsListPage_all_stores = "All Stores";
exports.stringsListPage_select_region = "Select Region";
exports.salesReportingEndPoint= {
  "Orders Sales Report": "bx_block_salesreporting/generate_excel_report",
  "Orders Revenue Report": "bx_block_salesreporting/order_revenue_report",
  "Laundry Sales & Revenue Report": "bx_block_salesreporting/generate_excel_for_sales_and_revenue_report",
  "Daily Sales Report": "bx_block_salesreporting/salesreportings/generate_excel_daily_sales_report",
  "Trend products Sales Report": "bx_block_salesreporting/salesreportings/trend_product_sales",
  "Adjustment Report": "bx_block_salesreporting/adjustment_report/generate_adjustment_report",
  "Consolidated Sales & Revenue Report": "bx_block_cffinancereport2/generate_finance_report",
  "Section & Service Sales Report": "bx_block_salesreporting/generate_excel_for_section_sales_report",
  "Carpet Section Orders Report": "bx_block_salesreporting/generate_carpet_orders_excel_report",
   "Finance Laundry Sales & Revenue Report": "bx_block_salesreporting/generate_excel_for_sales_and_revenue_report",
   "Finance Consolidated Sales & Revenue Report": "bx_block_cffinancereport2/generate_finance_report",
}
exports.reportType = {
  "Laundry Sales & Revenue Report": "Sales & Revenue Report",
  "Consolidated Sales & Revenue Report": "Finance Report"
}
exports.getIdsEndPoints = {
  companyId : "bx_block_company/companies?dropdown=true&type=b2b_company",
  customerId: "bx_block_account_groups/business_account_customers",
  businessAccId:'bx_block_cfcontractmanagement7/business_accounts'

}
exports.getAllRegionEndPoint = "bx_block_regions/regions?dropdown=true&allow_access=true"
exports.getDailySalesFiltersEndPoints = "bx_block_salesreporting/salesreportings/filter_columns_category_wise"
exports.getSectionSalesFiltesEndPoints = "bx_block_salesreporting/filter_columns_for_section_sales"
exports.getStoreListEndPoint =
  "bx_block_store_management/store_managements?dropdown=true&allow_access=true";
exports.top = "top";
exports.totalForEachColumn = "total_for_each_column"
exports.left = "left";
exports.bottom = "bottom";
exports.right = "right";
exports.center = "center";
exports.token = "token";
exports.toDatePlaceholder = "To Date";
exports.fromDataPlaceholder = "From Date";
exports.exportText = "Export";
exports.selectAll = "Select All";
exports.customizeText = "Customize";
exports.GroupId = "Group Ids";
exports.showOptionsTest = "show-options";
exports.directFields = [ "B2B Store Order Report",]
exports.revenueFields = [
  "B2B Orders Report Company wise",
  "B2B Client Order Report",
  "(B2B) Consolidated Orders Report"
]
exports.dynamicFilterFields = ['Section & Service Sales Report', 'Daily Sales Report']
exports.salesReportingEndPoint1= {
  "B2B Store Order Report": "bx_block_cfb2borderreport3/b2b_reports/generate_excel_for_b2b_store_orders_report",
  "B2B Orders Report Company wise": "bx_block_cfb2borderreport3/b2b_reports/generate_excel_for_b2b_orders_report_company_wise",
  "B2B Client Order Report": "bx_block_cfb2borderreport3/b2b_reports/generate_excel_for_b2b_customer_orders_report",
  "(B2B) Consolidated Orders Report": "bx_block_cfb2borderreport3/b2b_reports/generate_excel_for_b2b_consolidated_sales_report"
}

exports.salesReportType= {
  "B2B Store Order Report": "b2b_store_orders_report",
  "B2B Orders Report Company wise": "b2b_orders_report_company_wise",
  "B2B Client Order Report": "b2b_customer_orders_report",
  "(B2B) Consolidated Orders Report": "b2b_consolidated_sales_report"
}
exports.examplePostAPiMethod = "POST";
exports.pleaseSelectOneIcon = 'Please select valid field'
exports.test = "test"
exports.taskbarTest = "taskbar-test"
// Customizable Area End